import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import ProtectedRoute from './components/ProtectedRoute';
import ConsoleLayout from './components/layout/ConsoleLayout';
import Landing from './pages/Landing';
import LoginRedirect from './pages/LoginRedirect';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import Gpus from './pages/Gpus';
import Instances from './pages/Instances';
import Connect from './pages/Connect';
import ApiKeys from './pages/ApiKeys';
import AdvisorFab from './components/AdvisorFab';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename="/training">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<LoginRedirect />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route
            path="/console"
            element={
              <ProtectedRoute>
                <ConsoleLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="gpus" element={<Gpus />} />
            <Route path="instances" element={<Instances />} />
            <Route path="connect" element={<Connect />} />
            <Route path="keys" element={<ApiKeys />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <AdvisorFab />
      <Toaster
        position="top-right"
        toastOptions={{ style: { background: '#0D0D13', color: '#EDEDF0', border: '1px solid #34343F' } }}
      />
    </QueryClientProvider>
  );
}

export default App;
